import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

interface Props extends SvgIconProps {
  fill?: string;
}

const IconDuplicate: React.FC<Props> = ({ fill, ...other }) => (
  <SvgIcon viewBox="0 0 20 20" {...other}>
    <path
      d="M13.3849 4.76624C13.049 4.76624 12.7768 4.49402 12.7768 4.15817V0H7.70282C7.36697 0 7.0946 0.272217 7.0946 0.608215V3.41736H8.75049C8.91406 3.41736 9.06879 3.48358 9.18109 3.59573L13.9473 8.36212C14.0543 8.46893 14.1257 8.62335 14.1257 8.79181V16.3248H16.9348C17.2708 16.3248 17.5431 16.0524 17.5431 15.7166V4.76624H13.3849Z"
      fill="currentColor"
    />
    <path d="M13.993 0.859985V3.54996H16.683L13.993 0.859985Z" fill="currentColor" />
    <path
      d="M8.1427 8.79178V4.63361H3.06915C2.73315 4.63361 2.46094 4.90598 2.46094 5.24182V19.3918C2.46094 19.7278 2.73315 20 3.06915 20H12.3012C12.637 20 12.9094 19.7278 12.9094 19.3918V9.39999H8.75076C8.41507 9.39999 8.1427 9.12793 8.1427 8.79178Z"
      fill="currentColor"
    />
    <path d="M9.35901 8.18359H12.049L9.35901 5.49408V8.18359Z" fill="currentColor" />
  </SvgIcon>
);

export default IconDuplicate;
